import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
    const navigate = useNavigate();
    const { setUserDirect } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            navigate("/login");
            return;
        }
        const sessionId = decodeURIComponent(m[1]);

        (async () => {
            try {
                const { data } = await api.post("/auth/session", null, {
                    headers: { "X-Session-ID": sessionId },
                });
                setUserDirect(data);
                toast.success(`Καλώς ήρθες, ${data.name.split(" ")[0]}!`);
                // Clean URL fragment and go home
                window.history.replaceState(null, "", "/");
                navigate("/", { replace: true, state: { user: data } });
            } catch (err) {
                window.history.replaceState(null, "", "/login");
                toast.error("Σφάλμα σύνδεσης Google. Ξαναπροσπάθησε.");
                navigate("/login");
            }
        })();
    }, [navigate, setUserDirect]);

    return (
        <div className="min-h-[60vh] grid place-items-center" data-testid="auth-callback">
            <div className="flex items-center gap-3 text-white/70">
                <Loader2 className="animate-spin" size={20} />
                <span className="font-heading uppercase tracking-wider">Σύνδεση...</span>
            </div>
        </div>
    );
};
